jQuery( function( $ ) {
    const youtubeFrames = document.querySelectorAll( 'iframe[title="YouTube video player"]' );
    youtubeFrames.forEach( setAspectRatio );

    function setAspectRatio( frame ) {
        const wrapper = document.createElement( 'span' );
        wrapper.style.paddingTop = "56.25%";
        wrapper.style.display = "block";
        wrapper.style.position = "relative";
        frame.style.position = "absolute";
        frame.style.top = "0";
        frame.style.right = "0";
        frame.style.left = "0";
        frame.style.bottom = "0";
        frame.style.height = "100%";
        frame.style.width = "100%";
        frame.after( wrapper );
        wrapper.appendChild( frame );
    }
})